import { Controller } from "@hotwired/stimulus";
import { MDCDialog } from '@material/dialog';
import Rails from "@rails/ujs";

export default class extends Controller {
  static targets = [ "openDialogButton", "dialog"]

  initialize() {
    let _this = this;
    this.dialogTargets.forEach((dialogEl) => {
      if (dialogEl.dataset.dialogBound === "true") return;
      dialogEl.dataset.dialogBound = "true";

      let dialog = dialogEl.MDCDialog || new MDCDialog(dialogEl);

        if (dialogEl.dataset.dialogPreventAccidentalClose == "true") {
          dialog.escapeKeyAction = "";
          dialog.scrimClickAction = "";
        }

        let submitButton = dialogEl.querySelector("#dialog-submit-button");
        let fileUploadButton = dialogEl.querySelector('#file-upload-btn'); 
        let submitted = false; //To prevent double click.

        if (submitButton != null) {
          let form = dialogEl.querySelector('.mdc-dialog__content form.dialog-submit-form');
          let reload = submitButton.dataset.reload;

          if (form !== null && submitButton.dataset.enableWhenValid == "true") {
            let updateSubmitState = function() {
              submitButton.disabled = !form.checkValidity();
            };

            form.addEventListener("input", updateSubmitState);
            form.addEventListener("change", updateSubmitState);
            updateSubmitState();
          }

          submitButton.addEventListener("click", function(event) {
            if (form !== null && form.reportValidity() && !submitted) {
              submitted = true;
              let disabled_label = submitButton.dataset.disabledlabel;
              if (disabled_label != null && disabled_label.length > 0)
                submitButton.querySelector(".mdc-button__label").innerHTML = disabled_label;
              submitButton.disabled = true;

              if (form.dataset.remote && form.dataset.remote !== false) { 
                Rails.fire(form, 'submit');

                form.addEventListener("ajax:success", function (event) { 
                  const [_data, _status, xhr] = event.detail;

                  let response_html = xhr.responseText;

                  if (form.dataset.replaceId != null)
                    document.getElementById(form.dataset.replaceId).innerHTML = response_html;

                  dialog.close();
                });


                form.addEventListener("ajax:error", function(event) {
                  console.log("Error: ", error);
                  submitted = false;
                }); 


              } else { 
                form.submit() 
              }
            }

            if (reload == 'true')
              location.reload();

          });
        }

        if (fileUploadButton != null && fileUploadButton.tagName !== "LABEL" && fileUploadButton.getAttribute("for") == null) {
          fileUploadButton.addEventListener('click', function(event) {
            let fileInput = dialogEl.querySelector('input[type=file]');
            fileInput.click();
          });
        }
        
      openDialog(dialog);
    });


    this.openDialogButtonTargets.forEach((btn) => {
      if (btn.dataset.dialogOpenBound === "true") return;
      btn.dataset.dialogOpenBound = "true";

      btn.addEventListener("ajax:before", function(event) {
        //event.preventDefault();

        if (btn.dataset.process == "true") {
          event.preventDefault();
        } else {
          btn.dataset.process = "true";
          setTimeout(function() {
            btn.dataset.process = "false";
          }, 2000)
        }

      });

      btn.addEventListener("ajax:success", function(event) {
        btn.dataset.process = "false";
        const [_data, _status, xhr] = event.detail;
        let dialog_html = xhr.responseText;
        const div = document.createElement('div');
        div.innerHTML = dialog_html;
        const dialogEl = div.firstElementChild;

        if (btn.dataset.rtl == "true") {
          dialogEl.classList.add("rtl");
          dialogEl.setAttribute("dir", "rtl")
        }

        dialogEl.dialogTrigger = btn;
        document.body.appendChild(dialogEl);

      });

      btn.addEventListener("ajax:error", function(xhr, status, error) {
        btn.dataset.process = "false";
        console.log("Error: ", error);
      }); 

    });

    function openDialog(dialog) {
      if (dialog.root.querySelectorAll(".dialog-submit-form").length > 0) {
        let form_changed = false;

        dialog.listen('click', function(event) {
          if (form_changed == true && event.target != undefined && (event.target.classList.contains("mdc-dialog__scrim") || event.target.classList.contains("mdc-dialog__close"))) {
              
            let confirmationDialogTemplate = document.querySelector("#close-confirmation-dialog-template");
            let confirmationDialogEl = null;
            let confirmationDialog = null;

            const div = document.createElement('div');
            div.innerHTML = confirmationDialogTemplate.innerHTML;

            confirmationDialogEl = div.firstElementChild;
            if (confirmationDialogEl == null) return;

            if (dialog.root.getAttribute("dir") == "rtl") {
              confirmationDialogEl.classList.add("rtl");
              confirmationDialogEl.setAttribute("dir", "rtl")
            }

            document.body.appendChild(confirmationDialogEl);

            confirmationDialog = new MDCDialog(confirmationDialogEl);

            confirmationDialog.root.querySelector(".confirmation-dialog__button--discard").addEventListener("click", function () {
              confirmationDialog.close();
              dialog.close();
            });

            confirmationDialog.root.querySelector(".confirmation-dialog__button--continue")?.addEventListener("click", function () {
              confirmationDialog.close();
            });

            confirmationDialog.open();
          }
        });

        dialog.root.querySelectorAll("form").forEach(function (form) {
          
          form.addEventListener("input", function () {
            form_changed = true;
            preventDialogClosing(dialog);
          });

          form.addEventListener("event-registration-draft:saved", function () {
            form_changed = false;
            allowDialogClosing(dialog);
          });

          form.querySelectorAll(".mutation_observer").forEach(function (element) {

            var observer = new MutationObserver(function(mutations) {
              mutations.forEach(function(mutation) {
                form_changed = true;
                preventDialogClosing(dialog);
              });    
            });

            var config = { attributes: false, childList: true, characterData: true };
            observer.observe(element, config);
          });
        });
      }

      dialog.listen('MDCDialog:opened', () => {
        window.mdcAutoInit();
        _this.initFlatpickr();
        _this.focusInitialDialogElement(dialog.root);

        dialog.root.querySelectorAll("[data-dialog-reset-on-open='true']").forEach(function (form) {
          if (typeof form.reset === "function") {
            form.reset();
          }

          const keyInput = form.querySelector("[data-autocomplete-target='key']");
          const itemIdInput = form.querySelector("[data-autocomplete-target='itemId']");
          const submitButton = form.querySelector("[data-autocomplete-target='submit']");
          const outputList = form.querySelector("[data-autocomplete-target='output']");

          if (keyInput != null) keyInput.value = "";
          if (itemIdInput != null) itemIdInput.value = "";
          if (submitButton != null) submitButton.disabled = true;
          if (outputList != null) outputList.innerHTML = "";
        });
      });

      dialog.listen('MDCDialog:closing', function() {
      });

      dialog.listen('MDCDialog:opening', function() {
        dialog.root.querySelectorAll('.mdc-menu-surface').forEach(function(el) {
          el.classList.add("mdc-menu-surface--fixed");
        })
      });

      dialog.listen('MDCDialog:closed', function() {
        console.log(" dialog closed");
        const dialogTrigger = dialog.root.dialogTrigger;
        
        dialog.root.querySelectorAll('input').forEach(function(el) {
          el.blur();
        })
        setTimeout(function() {
          if (dialogTrigger instanceof HTMLElement && dialogTrigger.isConnected) {
            dialogTrigger.focus();
          }
        }, 0);
        setTimeout(function() {dialog.root.style.display = "none"; }, 100);
        setTimeout(function() {dialog.root.innerHTML= ""; }, 200);
        setTimeout(function() {
          if (dialog.root != null) {
            dialog.root.className = "mdc-dialog";
            dialog.root.removeAttribute('data-controller');
            dialog.root.removeAttribute('data-target');
          }
        }, 300);
      });

      dialog.open();
    }

    function preventDialogClosing(dialog) {
      dialog.escapeKeyAction= "";
      dialog.scrimClickAction= "";
      dialog.root.querySelectorAll(".mdc-dialog__close").forEach(function (btn) {
        btn.dataset.mdcDialogAction = '';
      });
    }

    function allowDialogClosing(dialog) {
      dialog.escapeKeyAction = "close";
      dialog.scrimClickAction = "close";
      dialog.root.querySelectorAll(".mdc-dialog__close").forEach(function (btn) {
        btn.dataset.mdcDialogAction = "close";
      });
    }
  }

  initFlatpickr() {
    flatpickr('.flatpickr', {
      enableTime: true,
      dateFormat: "Y-m-d H:i",
      time_24hr: true, 
      allowInput: true
    });

    flatpickr('.flatpickr_date', {
      dateFormat: "Y-m-d",
      allowInput: true
    });
      
    flatpickr('.flatpickr_time', {
      enableTime: true,
      noCalendar: true,
      enableSeconds: true,
      dateFormat: "H:i:S",
      time_24hr: true,
      allowInput: true
    });
  }

  updateSubmitState(event) {
    const form = event.currentTarget;
    const dialogRoot = form.closest(".mdc-dialog");
    const submitButton = dialogRoot?.querySelector("#dialog-submit-button");

    if (submitButton != null) submitButton.disabled = !form.checkValidity();
  }

  focusInitialDialogElement(dialogRoot) {
    const dialogContent = dialogRoot.querySelector(".mdc-dialog__content");
    const dialogActions = dialogRoot.querySelector(".mdc-dialog__actions");

    const autofocusCandidate = dialogRoot.querySelector(
      "[autofocus='autofocus'], [autofocus], textarea[autofocus='autofocus'], input[autofocus='autofocus'], select[autofocus='autofocus'], button[autofocus='autofocus']"
    );

    if (autofocusCandidate instanceof HTMLElement) {
      autofocusCandidate.focus();
      return;
    }

    const contentFocusable = dialogContent?.querySelector(
      "input:not([type='hidden']):not([disabled]):not([hidden]), textarea:not([disabled]):not([hidden]), select:not([disabled]):not([hidden]), [contenteditable='true'], button:not(.dialog-close-button):not([disabled]):not([hidden]), a[href]"
    );

    if (contentFocusable instanceof HTMLElement) {
      contentFocusable.focus();
      return;
    }

    const actionFocusable = dialogActions?.querySelector(
      "button:not(.dialog-close-button):not([disabled]):not([hidden]), a[href]"
    );

    if (actionFocusable instanceof HTMLElement) {
      actionFocusable.focus();
      return;
    }

    const fallback = dialogContent?.querySelector(".mdc-dialog__content-inner") || dialogRoot.querySelector(".mdc-dialog__surface");
    if (fallback instanceof HTMLElement) {
      fallback.setAttribute("tabindex", "-1");
      fallback.focus();
    }
  }

}
